"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireWildcard(require("../Input"));

require("cleave.js/dist/addons/cleave-phone.no.js");

var _theming = require("../../../../theming");

var _countries = _interopRequireWildcard(require("../../../../data/countries"));

var _Select = _interopRequireDefault(require("../../Select/Select"));

var _Label = _interopRequireDefault(require("../../Label/Label"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Input for Phone-numbers.
 * TODO: normalize country code and locale
 */
var PhoneInput = _react["default"].forwardRef(function (_ref, ref) {
  var locale = _ref.locale,
      label = _ref.label,
      _ref$showCountryCode = _ref.showCountryCode,
      showCountryCode = _ref$showCountryCode === void 0 ? false : _ref$showCountryCode,
      _ref$initialCountry = _ref.initialCountry,
      initialCountry = _ref$initialCountry === void 0 ? _countries.NORWAY : _ref$initialCountry,
      _ref$initialCountryCo = _ref.initialCountryCode,
      initialCountryCode = _ref$initialCountryCo === void 0 ? _countries.NORWAY.code : _ref$initialCountryCo,
      onCountryChange = _ref.onCountryChange,
      otherProps = _objectWithoutProperties(_ref, ["locale", "label", "showCountryCode", "initialCountry", "initialCountryCode", "onCountryChange"]);

  return _react["default"].createElement(PhoneInputWrapper, otherProps, _react["default"].createElement(_Label["default"], otherProps, label), _react["default"].createElement(Wrap, otherProps, showCountryCode && _react["default"].createElement(CountryCode, null, _react["default"].createElement(_Select["default"], _extends({}, otherProps, {
    items: _countries["default"],
    itemToString: function itemToString(item) {
      return "+".concat(item.code);
    },
    itemToKey: function itemToKey(item) {
      return item.code;
    },
    initialSelectedItem: initialCountryCode ? _countries["default"].find(function (c) {
      return c.code === initialCountryCode;
    }) : initialCountry,
    onChange: function onChange(country) {
      if (onCountryChange) {
        onCountryChange(country);
      }
    }
  }))), _react["default"].createElement(PInput, _extends({
    type: "tel",
    ref: ref,
    options: {
      phone: true,
      phoneRegionCode: locale
    }
  }, otherProps))));
});

PhoneInput.themeProps = {
  wrapper: {
    name: "PHONE_WRAPPER",
    description: "Wrapper style",
    type: _theming.themePropTypes.style
  },
  countryCode: {
    name: "PHONE_COUNTRY_CODE",
    description: "Country code style",
    type: _theming.themePropTypes.style
  },
  input: {
    name: "PHONE_INPUT",
    description: "Specific Input style",
    type: _theming.themePropTypes.style
  }
};

var PhoneInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PhoneInput__PhoneInputWrapper",
  componentId: "hk17i2-0"
})(["position:relative;"]);

var Wrap = _styledComponents["default"].div.withConfig({
  displayName: "PhoneInput__Wrap",
  componentId: "hk17i2-1"
})(["width:100%;position:relative;display:flex;align-items:flex-end;justify-content:space-between;", ";"], (0, _theming.applyVariants)(PhoneInput.themeProps.wrapper));

var CountryCode = _styledComponents["default"].div.withConfig({
  displayName: "PhoneInput__CountryCode",
  componentId: "hk17i2-2"
})(["flex-grow:0.3;margin-right:", ";"], _theming.spacing.small);

var PInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "PhoneInput__PInput",
  componentId: "hk17i2-3"
})(["flex-grow:1;", ";"], (0, _theming.applyVariants)(PhoneInput.themeProps.input));
PhoneInput.propTypes = _objectSpread2({}, _Input.InputPropTypes, {
  locale: _propTypes["default"].oneOf(["no"]),
  onChange: _propTypes["default"].func,
  guide: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired
});
PhoneInput.defaultProps = {
  locale: "no",
  guide: false
};
var _default = PhoneInput;
exports["default"] = _default;